import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Clinicas, UnidadesClinicaData } from '@fcp/lib-ui';

@Injectable({
  providedIn: 'root'
})
export class UnidadesClinicaContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getUnidadesClinica(id: string): Observable<any> {
    return this.getUnidadesClinicaContents(id).pipe(
      map(res => this.mapUnidadesClinica(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryUnidadesClinicaContents[0].flatData;
  }

  private getUnidadesClinicaContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryUnidadesClinicaContents(filter: "id eq '${id}'") {
          flatData {
            titulo
            clinica {
              nomeClinica
              endereco
              horarios
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private mapUnidadesClinica(response) {
    let clinicas: Array<Clinicas> = [];
    if (response.clinica) {
      clinicas = response.clinica.map(
        (item): Clinicas => {
          return {
            name: item.nomeClinica,
            address: item.endereco,
            hours: item.horarios
          };
        }
      );
    }

    return {
      title: response.titulo,
      clinicas
    } as UnidadesClinicaData;
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
